/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_BOX = gql`
  query GetBoxes($filter: BoxFilterInput) {
    getCurrencyExchangeRate {
      payment_mode
      conversion_rate
      currency
      provider
    }
    getBoxes(filter: $filter) {
      content {
        id
        _id
        costumeID
        boxStatus
        paymentStats
        totalAmount
        delegateName
        amountPaid
        totalAmountInUSD
        totalAmount
        amountPaidInUSD
        availableTime
        address {
          city
          addressLine1
        }
        user {
          vuid
          firstName
          lastName
          email
          mailAddress {
            addressLine1
            city
          }
          address {
            addressLine1
            city
          }
        }
        delivery {
          isOpted
          partner
          status
          trackingId
        }
        presentation {
          id
          name
          year
          type
          status
          createdAt
        }
        section {
          id
          name
        }
        items {
          isPaid
          paidAmount
          bookedPrice
          costumeType {
            name
            description
            images
            id
            minDownPayment
          }
          costumeFeature {
            id
            name
            alias
            isSingleAttribute
            isVisible
            isMandatory
            costumeAttributes {
              id
              name
              images
              isMandatory
              isSingleVal
              isVisible
              costumeValues {
                id
                name
                inventory
                isVisible
                topupPrice
                disclaimer
                isCostumeValueSold
              }
            }
          }
          costumeAttribute {
            id
            name
            images
            isMandatory
            isSingleVal
            isVisible
            costumeValues {
              id
              name
              inventory
              isVisible
              topupPrice
              disclaimer
              isCostumeValueSold
            }
          }
          costumeValue {
            id
            name
            inventory
            isVisible
            topupPrice
            disclaimer
            isCostumeValueSold
            minDownPayment
          }
        }
        payOrder {
          id
          orderId
          paymentStatus
          updatedAt
          payTxes {
            id
            amount
            mode
            reciptId
            status
            resolutionStatus
            errorMessage
            txId
            createdAt
            payMethod
            createdByUser {
              fullName
              email
            }
          }
        }
        boxTxes {
          action
          actionContent
          box
          createdAt
          displayTitle
          user {
            vuid
            firstName
            lastName
            email
          }
          reason
        }
        isPreBooking
        groupId
      }
    }
  }
`;
